import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Columns = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="columns icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 3.982C0 2.87743 0.895431 1.98199 2 1.98199H4C5.10457 1.98199 6 2.87743 6 3.98199V19.982C6 21.0866 5.10457 21.982 4 21.982H2C0.89543 21.982 0 21.0866 0 19.982L0 3.982ZM8.5 3.982C8.5 2.87743 9.39543 1.98199 10.5 1.98199H12.5C13.6046 1.98199 14.5 2.87743 14.5 3.98199V19.982C14.5 21.0866 13.6046 21.982 12.5 21.982H10.5C9.39543 21.982 8.5 21.0866 8.5 19.982V3.982ZM17 3.982C17 2.87743 17.8954 1.98199 19 1.98199H22C23.1046 1.98199 24 2.87743 24 3.98199V19.982C24 21.0866 23.1046 21.982 22 21.982H19C17.8954 21.982 17 21.0866 17 19.982V3.982ZM19 4.98199C19 4.42971 19.4477 3.98199 20 3.98199H21C21.5523 3.98199 22 4.42971 22 4.98199V18.982C22 19.5343 21.5523 19.982 21 19.982H20C19.4477 19.982 19 19.5343 19 18.982V4.98199Z"
    />
  </svg>
)
